module.exports = __webpack_public_path__ + "img/holidayinn-logo.36f18ef4.jpg";